export enum Currencies {
    CAD = 0,
    USD = 1,
    EUR = 2,
    GBP = 3,
    MXN = 4
}

export enum DeliveryOptions {
    Regular = 0,
    Express = 1,
    Overnight = 2,
    Store = 3,
    Partner = 4,
    Pickup = 5,
    HasTracking = 6,
    Prime = 7
}

export enum CartStatuses {
    Unknown = 0,
    Open = 1,
    Processing = 2,
    Closed = 3,
    Cancelled = 4,
    OnHold = 5,
    Returned = 6
}

export enum ProductStatuses {
    Discontinued = 0,
    Active = 1, Refund = 0,
    Payment = 1,
    Adjustment = 2,
    Fee = 3
}

export enum PaymentTypes {
    Unknown = 0,
    Instant = 1,
    CreditCard = 2,
    PayPal = 3,
    GiftCard = 4,
    Cheque = 5,
    Marketplace = 6,
    Debit = 7,
    Manual = 8,
    Partner = 9,
}

export enum TransactionTypes {
    Refund = 0,
    Payment = 1,
    Adjustment = 2,
    Fee = 3
} 


export enum CartShipmentStatuses {
    Cancelled = 0,
    Active = 1,
    Archived = 2,
}

export enum ShippingServiceProviders {
    ShipStation = 0,
    Zazzle = 1,
    ShipEngine = 2,
    Amazon = 3,
    Manual = 4
}

export enum ProcessStatuses {
    Created = 0,
    Running = 1,
    Completed = 2,
    Stopped = 3,
    Errored = 4,
    Sleeping = 5
}

export enum MessageTypes {
    Success = 0,
    Info = 1,
    Warning = 2,
    Danger = 3,
}

export enum AccountCreditStatuses {
    New = 0,
    Used = 1,
    Pending = 2,
    Available = 3,
    Cancelled = 4,
}

export enum ShipmentPackageTypes {
    SM = 0,
    LG = 1,
    XL = 2,
    XXL = 3,
}

export enum SvgCanvasTypes {
    MyMoji = 0,
    CustomProduct = 1,
    PetMoji = 2,
}

export enum ListingActionType {
    None = 0,
    Create = 1,
    Update = 2,
    Delete = 3,
    Refresh = 4
}

export enum ListingStatus {
    Unknown = 0,
    NewlyCreated = 1,
    Updated = 2,
    Deleted = 3,
    Problematic = 4
}

export enum ListingActionStatus {
    None = 0,
    Pending = 1,
    InProgress = 2,
    Complete = 3,
    Failed = 4,
}

export enum ProductType {
    Product = 0,
    Package = 1
}